import { useQuery } from '@tanstack/react-query';
import { api } from '@/api/client';
import type { AdminAcquisitionOverview, AdminFunnelCountryRow } from '../users-and-agents/api';

export type AcquisitionGrouping = 'source' | 'medium' | 'campaign';
export type AcquisitionRange = { from?: string; to?: string; game: string; exclude_bots: 'true' };
function path(endpoint: string, params: Record<string, string | undefined>) {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => { if (value) query.set(key, value); });
  return `/v1/admin/users-agents/${endpoint}?${query}`;
}
// Preserve the serving API's actual counts: the People normalizer falls back
// from a legitimate zero landing_visit to visitors, which is not this metric.
export function useOrganicAcquisition(range: AcquisitionRange, grouping: AcquisitionGrouping, enabled: boolean) {
  return useQuery({
    queryKey: ['admin', 'organic-acquisition', range, grouping],
    queryFn: () => api.get<AdminAcquisitionOverview>(path('acquisition-overview', { ...range, source_granularity: grouping })),
    enabled, staleTime: 60_000, refetchOnWindowFocus: false,
  });
}
export function useOrganicCountries(range: AcquisitionRange, enabled: boolean) {
  return useQuery({
    queryKey: ['admin', 'organic-countries', range],
    queryFn: () => api.get<{ data: AdminFunnelCountryRow[] }>(path('funnel-by-country', range)),
    enabled, staleTime: 60_000, refetchOnWindowFocus: false,
  });
}
